import Form from "@/shared/form/form";
import { useState } from "react";
import { RouteStepType } from "./types";

export function useRouteStepType({
  fullPath,
}: {
  fullPath: (string | number)[];
}) {
  const form = Form.useFormInstance();

  const [routeStepType, setRouteStepType] = useState<RouteStepType>(() => {
    const step = form.getFieldValue(fullPath);

    return step?.role ? "role" : step?.person ? "person" : undefined;
  });

  const clear = () => {
    form.setFieldValue(fullPath, {
      ...form.getFieldValue(fullPath),

      role: undefined,
      person: undefined,
    });
  };

  const changeRouteStepType = (type: RouteStepType) => {
    clear();
    setRouteStepType(type);
  };

  return {
    routeStepType,
    changeRouteStepType,
  };
}
